import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingHappyHorseAiVideoGeneratorConfig } from '@/data/landingConfig/landingHappyHorseAiVideoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_HappyHorseAiVideoGenerator } from './schemaObject';

interface Props {}
const HappyHorseAiVideoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_HappyHorseAiVideoGenerator} />
			<LandingTemplate
				data={landingHappyHorseAiVideoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default HappyHorseAiVideoGenerator;
